<template>
    <board-detail-link :boardData="boardData" :boardLayout="detailLayout" :boardKey="boardKey" :contentType="contentType"></board-detail-link>
</template>

<script>
    import boardTemplateUtil from "@/components/board/boardTemplateUtil"
    import boardFilterUtil from "@/components/board/boardFilterUtil"
    import BoardDetailLink from "@/components/board/BoardDetailLink";
    import alertMixins from "@/mixins/alertMixins";
    import util from "@/mixins/util";
    import EventBus from "@/utils/event-bus";
    import DeleteClass from "@/mixins/deleteClass";

    export default {
        name: "BoardDetailComponent",
        mixins: [boardTemplateUtil, boardFilterUtil, alertMixins],
        components: {
            BoardDetailLink
        },
        inject: ['changeLoading'],
        provide() {
            return{
                boardDetailDelete: this.runDeleteConfirm,
            }
        },
        props: {
            boardType: {
                type: String,
            },
            boardKey: {},
            ssamsKey: {}
        },
        data() {
            return{
                detailLayout: '',
                getFunc: null,
                detailApiParamSet: {},
                deleteFunc: '',
                deleteApiParamsSet: {},
                deleteSuccessType: 1,
                deleteFailTypes: {},
                keyName: '',
                DeleteClass: null,
                boardData: {},
                contentType : ''
            }
        },
        beforeRouterEnter() {},
        created() {
            this.initConfig();
            this.getDetail();
            this.initTemplateConfig();

        },
        mounted() {
          EventBus.$on('getBoardDetail', this.getDetail);
        },
        beforeDestroy() {
          EventBus.$off('getBoardDetail');
        },
        destroyed() {},
        computed: {
        },
        methods:{
            initConfig(){
                let boardFilterConfig = this.returnBoardFilterConfig(this.boardType);
                this.getFunc = boardFilterConfig.getFunc;
                this.detailApiParamSet = boardFilterConfig.detailApiParamSet;
                this.deleteFunc = boardFilterConfig.deleteFunc;
                this.deleteApiParamsSet = boardFilterConfig.deleteApiParamsSet;
                this.deleteSuccessType = boardFilterConfig.deleteSuccessType;
                this.deleteFailTypes = boardFilterConfig.deleteFailTypes;
                this.keyName = boardFilterConfig.keyName;
                this.contentType = boardFilterConfig.contentType;
                this.newDeleteClass();
            },
            initTemplateConfig(){
              let boardTemplateConfig = this.returnBoardTemplateConfig(this.boardType);
              this.detailLayout = boardTemplateConfig.detailLayout;
            },
            newDeleteClass() {
                if(!util.isEmpty(this.deleteFunc)) {
                    let deleteOptions = {
                        func: this.$api.$board[this.deleteFunc],
                        apiParamSet: this.deleteApiParamsSet,
                        keyName: this.keyName,
                        successType: this.deleteSuccessType,
                        errorTypes: this.deleteFailTypes,
                        afterFunc: this.deleteAfterFunc,
                    }
                    this.DeleteClass = new DeleteClass(deleteOptions);
                }
            },
            getDetail() {
                if(this.boardKey === 0) {
                    this.createAlert({
                        content: '상세를 가져올 수 없습니다.',
                        hide: () => {
                            this.$router.back();
                        }
                    })
                }
                let params = JSON.parse(JSON.stringify(this.detailApiParamSet));
                params.id = this.boardKey;
              params.sid = this.ssamsKey;
                try {
                    this.$api.$board[this.getFunc](params).then(res => res.Data.Result).then(res => {
                        if(res.Info.type != 1 || util.isEmpty(res.List)) {
                            this.createAlert({
                                content: '상세를 가져올 수 없습니다.',
                                hide: () => {
                                    this.$router.back();
                                }
                            })
                            return false;
                        }
                        this.boardData = res.List[0];
                        EventBus.$emit(`${this.detailLayout}ForceUpdate`)
                    })
                }catch (e) {

                }
            },
            runDeleteConfirm() {
                this.createConfirm({
                    content: '정말 삭제하시겠습니까?',
                    confirm: () => {

                        this.runDelete();
                    }
                })
            },
            runDelete() {
                this.changeLoading(true);
                this.DeleteClass.runDelete(this.boardKey);
            },
            deleteAfterFunc() {
                this.changeLoading(false);
                this.createAlert({
                    content: '삭제되었습니다.',
                    hide: () => {
                        this.$router.back();
                    }
                })
            },
        },
        watch: {

        },
    }
</script>

<style scoped>

</style>
